import React from "react";

// A phone drawn in CSS around a real screenshot: a slim dark bezel with a gold
// hairline (Anant, 6 Oct: the thick gold border was too heavy). Radii are percentages so the
// frame keeps its shape at any width (the trio scales with its container).
export function Phone({ src, alt, className = "", eager = false, style }) {
  return (
    <div
      className={`bg-[#0a0d18] p-[1.1%] ring-1 ring-[#c9a15f]/55 shadow-[0_40px_70px_-35px_rgba(0,0,0,0.85)] ${className}`}
      style={{ borderRadius: "12.5% / 5.8%", ...style }}
    >
      <img
        src={src}
        alt={alt}
        loading={eager ? "eager" : "lazy"}
        decoding="async"
        width="720"
        height="1564"
        className="block w-full h-auto bg-[#060914] select-none"
        style={{ borderRadius: "11.5% / 5.3%" }}
        draggable={false}
      />
    </div>
  );
}

// Three phones, the centre one forward. `screens` is [left, centre, right].
export function PhoneTrio({ screens, className = "", eager = false }) {
  const [l, c, r] = screens;
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <Phone
        src={l.src}
        alt={l.alt}
        eager={eager}
        className="w-[31%] translate-x-[16%] rotate-[-4deg] opacity-95"
      />
      <Phone src={c.src} alt={c.alt} eager={eager} className="relative z-10 w-[38%]" />
      <Phone
        src={r.src}
        alt={r.alt}
        eager={eager}
        className="w-[31%] -translate-x-[16%] rotate-[4deg] opacity-95"
      />
    </div>
  );
}
